import { useEffect } from "react";
import { useMap } from "@vis.gl/react-google-maps/dist/index.umd.js";

type UseMapCameraSyncParams = {
  center?: google.maps.LatLngLiteral;
  zoom?: number;
};

export function useMapCameraSync({ center, zoom }: UseMapCameraSyncParams) {
  const map = useMap();

  useEffect(() => {
    if (map && center && typeof map.panTo === "function") {
      map.panTo(center);
    }
  }, [center, map]);

  useEffect(() => {
    if (
      map &&
      typeof zoom === "number" &&
      typeof map.getZoom === "function" &&
      map.getZoom() !== zoom
    ) {
      map.setZoom(zoom);
    }
  }, [map, zoom]);
}
